import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import sys from '@/request/api/sys'
import store from '@/store'

Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: '/login',//重定向

  }
  , {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login')
  }
];

const router = new Router({
  mode: 'history',
  base: '/guest/',
  routes
})
//解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 在路由完成初始导航时调用，如果有异步操作放置到这里
router.onReady(async () => {

})
//路由全局导航守卫
router.beforeEach( async (to, from, next) => {

  if (to.path == "/login" || to.path.startsWith("/web/") ) {
    return next();
  } else {
    // console.log("拦截了：：",to.path);
    const loginUserId = store.state.loginUser.loginUser.id;

    if (!loginUserId) {//没有token-重新登录
      return next("/login")
    } else {
      // console.log('是否有菜单',store.state.navBar.nav.length,store.state.navBar.nav)
      if (store && store.state.navBar.nav.length == 0) {
        let home=await initRouterData();
        // 重置路由  解决警告问题
        router.matcher = new Router({
          mode: 'history',
          base: '/guest/',
          routes
        }).matcher
        router.addRoute(home);
        return next({...to});
      } else {
        // console.log('有缓存')
        return next();
      }
    }
  }
})
//设置路由数据
async function initRouterData() {
  // console.log('初始化roter')
  const {dynamicRoutes,firstNav}=await initBarData();
  // console.log('第一个标签',firstNav)
  //  没有缓存
  //默认布局页及首页
  let home = {
    path: '/home',/*布局页*/
    name: 'Home',
    // redirect: '/tabClass',
    redirect: firstNav.path,//默认显示第一个
    component: Home,
    meta: {title: '首页', isTabsPage: true},
    children: [
      // {
      //   path: '/welcome',
      //   name: 'Welcome',
      //   meta: {title: '首页',isTabsPage: true},
      //   component: () => import('../components/Welcome')
      // }
    ]
  }

  //动态内容追加进去
  home.children.push(...dynamicRoutes);


  // //动态路由追加
  // router.addRoute(home);
  return home;
}
//初始化数据
async function initBarData() {
  var redate,firstNav;

  // console.log('111111',store)
  if (window.sessionStorage.getItem("navBar")) {
    const dddd = JSON.parse(window.sessionStorage.getItem("navBar"));
    //解析成路由格式
    redate = addDynamicRoutes(dddd);
    firstNav=redate[0];
    if(firstNav.navChildren && firstNav.navChildren.length>0) {
      firstNav = firstNav.navChildren[0];
    }
    //store存储原始数据
    store.dispatch('SETNAV', dddd);
    window.sessionStorage.removeItem('navBar');
  } else {
    //  没有缓存
    const res = await sys.leftMenus();

    //解析成路由格式
    redate = addDynamicRoutes(res.data);
    //获取第一个标签，设置默认 tabs
    firstNav=redate[0];
    if(firstNav.navChildren && firstNav.navChildren.length>0) {
      firstNav = firstNav.navChildren[0];
    }
    //store存储原始数据
    store.dispatch('SETNAV', res.data);
    //动态生成tabs第一个标签
    store.dispatch('RESET_TAB',{tabsValue:[{title:firstNav.meta.title,path:firstNav.path,name:firstNav.path}],activePath:firstNav.path});
  }
  return {dynamicRoutes:redate,firstNav:firstNav};
}
//解析成tree
function addDynamicRoutes(res) {
  let tmpRoutes = [];
  if(!res)return;
  res.forEach(v => {
    // console.log('监控',v.title,v.type)
    if (v.type != '2') {//2为操作按钮
      // console.log("进来了")
      let children = [];
      // console.log(v.name)

      if(v.path && v.path!="#"){//正常目录
        if (v.navChildren && v.navChildren.length > 0) {
          // console.log('vvv:',v,'length::'+v.navChildren.length)
          //存在子集
          children = addDynamicRoutes(v.navChildren);
        }
        tmpRoutes.push({
          path: v.path,
          name: v.name,
          meta: {title: v.title,czbtns:v.czbtns||[]},
          component: () => import('../' + v.component),
          children: children
        })
      }else{//该目录不作为加载路径
        tmpRoutes.push(...addDynamicRoutes(v.navChildren));
      }

    }

  })
  return tmpRoutes;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js